import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';
import { styled, Typography } from '@mui/material';
import UrlShortener from 'src/components/UrlShortener';

const QRCodeGenerator: React.FC<{ url: string }> = ({ url }) => {
  const qrCodeRef = useRef(null);
  const qrCode = new QRCodeStyling({
    width: 200,
    height: 200,
    data: url, // Replace this with the URL you want
    dotsOptions: {
      color: '#32358F', // Foreground color
      type: 'square',
    },
    backgroundOptions: {
      color: '#ffffff', // Background color
    },
  });

  useEffect(() => {
    if (qrCodeRef.current) {
      qrCode.append(qrCodeRef.current);
    }
  }, []);

  return (
    <QrCodeWrapper>
      <Typography variant="h4">Try it on another device:</Typography>
      <Typography variant="body2">Do you want to try out the authentication from another device? Copy the link below or scan the QR code.</Typography>
      <UrlShortener url={url} />
      <div style={{ marginTop: 16 }} ref={qrCodeRef}></div>
    </QrCodeWrapper>
  );
};

export default QRCodeGenerator;

const QrCodeWrapper = styled('div')(({ theme }) => ({
  padding: 16,
  '& h4': {
    fontSize: 16,
    marginTop: 0,
    marginBottom: 12,
  },
  '& p': {
    fontSize: 14,
    marginBottom: 12,
    color: theme.palette.text.primary,
  },
}));
